const KUA_TOPICS = [
  { name: "剧圈 × 舞台", count: "24条", pct: "bg-primary-500" },
  { name: "音综 × 影综", count: "19条", pct: "bg-accent-500" },
  { name: "综艺老友 × 新节目", count: "16条", pct: "bg-secondary-500" },
  { name: "影视 OST × 现场", count: "11条", pct: "bg-primary-300" },
];

const TRACKS = [
  {
    title: "同框即“官宣”？娱乐工业里的联动营销套路拆解",
    tag: "深度",
    excerpt:
      "从官微预热、路透放风到正式官宣，一套成熟的联动宣发节奏背后其实有迹可循。小编用时间轴帮你看清来路。",
  },
  {
    title: "饭圈“串门”礼仪指南：跨界互动时别踩这些雷",
    tag: "科普",
    excerpt:
      "跨圈围观最容易在措辞上翻车，本文整理了几条已被反复验证的吃瓜边界与互动分寸。",
  },
  {
    title: "瓜有真假：教你三招判断一张路透图的可信度",
    tag: "指南",
    excerpt:
      "高清到爆的路透未必保真，本文从图源、时间戳与多方佐证三个角度教你理性吃瓜不站错队。",
  },
];

export default function KuaSection() {
  return (
    <section id="kua" className="scroll-mt-20 bg-background-50 py-10 md:py-14">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
          {/* left tracker */}
          <div className="rounded-3xl border border-background-200 bg-background-100/50 p-6 lg:col-span-2 lg:p-7">
            <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-400" /> HEAT MAP
            </p>
            <h2 className="mt-2 font-display text-2xl text-foreground-900 md:text-3xl">
              跨圈追踪
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              本周大家最爱在哪条“线”上吃瓜？按热度把联动方向排个队。
            </p>

            <div className="mt-6 space-y-4">
              {KUA_TOPICS.map((t) => (
                <div key={t.name}>
                  <div className="mb-1.5 flex items-center justify-between text-sm">
                    <span className="text-foreground-800">{t.name}</span>
                    <span className="text-xs text-foreground-400">{t.count}</span>
                  </div>
                  <div className="h-2.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className={`h-full rounded-full ${t.pct}`}
                      style={{ width: `${Math.random() * 55 + 40}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 rounded-2xl bg-primary-500 p-5 text-background-50">
              <p className="font-medium">跨圈指数</p>
              <p className="mt-1 font-display text-3xl">128<span className="text-xl">↑</span></p>
              <p className="mt-1 text-sm text-primary-100">
                较上周上升，联动与串门类话题贡献了主要声量。
              </p>
            </div>
          </div>

          {/* right depth tracks */}
          <div className="flex flex-col gap-4 lg:col-span-3">
            {TRACKS.map((t) => (
              <article
                key={t.title}
                className="group flex flex-col justify-between gap-3 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 sm:flex-row sm:items-center md:p-6"
              >
                <div className="min-w-0 flex-1">
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                    {t.tag}
                  </span>
                  <h3 className="mt-3 font-medium leading-snug text-foreground-900 group-hover:text-primary-600">
                    {t.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600">{t.excerpt}</p>
                </div>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-background-100 text-xl text-foreground-400 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-line" />
                </span>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}